import { getGridPlacement, isInside } from "../utils/rects";
import { getNormalizedElementRect } from "../utils/screen";
/**
 * Returns IDs of droppables hovered by the draggable rect.
 */
export function getHoveredDroppables(collisionRect, droppables) {
    const droppableRects = droppables.map(([, element]) => getNormalizedElementRect(element));
    const bounds = getGridPlacement(collisionRect, droppableRects);
    return droppables.filter((_, index) => isInside(droppableRects[index], bounds)).map(([droppableId]) => droppableId);
}
//# sourceMappingURL=get-hovered-droppables.js.map